// extracted by mini-css-extract-plugin
export default {"container":"ViewEvent_container__R6v2Z","tblcontainer":"ViewEvent_tblcontainer__Pugnp","paymentstatus":"ViewEvent_paymentstatus__o410c","newempbtn":"ViewEvent_newempbtn__lAUG7"};